// lib/adsense-protection.js
export const protectAdSense = () => {
  try {
    let clickCount = 0;
    let lastClickTime = 0;
    const MAX_CLICKS = 3;
    const BLOCK_DURATION = 60 * 1000; // 1 minute

    document.addEventListener("click", (e) => {
      const target = e.target.closest("ins");
      const now = Date.now();

      if (target && target.className.includes("adsbygoogle")) {
        if (now - lastClickTime < 3000) {
          clickCount++;
        } else {
          clickCount = 1;
        }

        lastClickTime = now;

        if (clickCount >= MAX_CLICKS) {
          const ads = document.querySelectorAll("ins.adsbygoogle");
          ads.forEach((ad) => {
            ad.style.display = "none";
          });
          console.warn("⚠️ AdSense clicks hidden due to suspicious behavior.");
          setTimeout(() => {
            ads.forEach((ad) => (ad.style.display = ""));
            clickCount = 0;
          }, BLOCK_DURATION);
        }
      }
    });
  } catch (err) {
    console.error("AdSense protection error:", err);
  }
};
